import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getBusinessProcessesActivePlanWorks(companyId, query) {
	return  dataTransferWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		dtConfig[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].getBusinessProcessesActivePlanWorks, {
		urlParams: {
			companyId,
		},
		params: query,
	})
}

function getBusinessProcessesActivePlanWorkPopup(companyId, activePlanWorkId) {
	return  dataTransferWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		dtConfig[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].getBusinessProcessesActivePlanWorkPopup, {
		urlParams: {
			companyId,
			activePlanWorkId,
		},
	})
}

function getBusinessProcessesActivePlanWorksPreview(companyId, activePlanWorkId) {
	return  dataTransferWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		dtConfig[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].getBusinessProcessesActivePlanWorksPreview, {
		urlParams: {
			companyId,
			activePlanWorkId,
		},
	})
}

function getBusinessProcessesActivePlanWork(companyId, activePlanWorkId) {
	return  dataTransferWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		dtConfig[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS].getBusinessProcessesActivePlanWork, {
		urlParams: {
			companyId,
			activePlanWorkId,
		},
	})
}

export default {
    getBusinessProcessesActivePlanWorks,
    getBusinessProcessesActivePlanWorkPopup,
    getBusinessProcessesActivePlanWorksPreview,
    getBusinessProcessesActivePlanWork,
}
